var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ryvyl-form"},[_c('form',{staticClass:"paymentWidgets",attrs:{"action":_vm.redirectUrl,"data-brands":"VISA MASTER AMEX"}}),_c("script",{tag:"component",attrs:{"src":_vm.scriptSrc,"integrity":_vm.integrity,"crossorigin":"anonymous","async":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }